import axios from 'axios';

export const API_URL = 'https://api.planium.tech';
const PROFILE_URL = '/main/api/client/profile/';
const PUBLIC_AUTH = new Set([
  '/main/api/client/auth/request-call/',
  '/main/api/client/auth/request-email/',
  '/main/api/client/auth/verify-code/',
]);
export const clientAxios = axios.create({ baseURL: API_URL });
const probes = new Map();
const invalidSession = error => [401, 403].includes(error.response?.status)
  && error.response?.data?.code === 'client_session_invalid';

function expireSession(token) {
  if (!token || localStorage.getItem('client_token') !== token) return;
  localStorage.removeItem('client_token');
  window.dispatchEvent(new Event('client_unauthorized'));
}

clientAxios.interceptors.request.use(config => {
  const path = new URL(config.url, config.baseURL || API_URL).pathname;
  config.headers = config.headers || {};
  const currentToken = localStorage.getItem('client_token');
  // Upload queues pin the author at creation. Never send an old job as a new
  // account if a login changes before Axios runs its async interceptors.
  const token = config.clientSessionToken ?? currentToken;
  if (config.clientSessionToken != null && token !== (currentToken || '')) {
    throw new axios.CanceledError('Сессия изменилась. Откройте нужный чат заново.');
  }
  if (PUBLIC_AUTH.has(path)) {
    delete config.headers.Authorization;
  } else if (token) {
    config.headers.Authorization = `ClientToken ${token}`;
  }
  return config;
});

clientAxios.interceptors.response.use(res => res, async error => {
  const headers = error.config?.headers;
  const header = headers?.get?.('Authorization') || headers?.Authorization;
  const token = typeof header === 'string' && header.startsWith('ClientToken ')
    ? header.slice('ClientToken '.length) : null;
  if (!token || token !== localStorage.getItem('client_token')) throw error;
  if (invalidSession(error)) {
    expireSession(token);
  } else if ([401, 403].includes(error.response?.status)) {
    // Отказ новостей/прав не означает потерю сессии. Проверяем профиль отдельно.
    // Чистый axios не запускает этот interceptor повторно.
    if (!probes.has(token)) {
      probes.set(token, axios.get(`${API_URL}${PROFILE_URL}`, {
        headers: { Authorization: `ClientToken ${token}` }, timeout: 15000,
      }).then(() => false, probeError => invalidSession(probeError))
        .finally(() => probes.delete(token)));
    }
    if (await probes.get(token)) expireSession(token);
  }
  throw error;
});
